module.exports = __webpack_public_path__ + "assets/527d326d8b0f3dd6fc4d2f93b5557123.mp3";